import { ActivityLogsState } from './activity-logs.state';

export function ActivityLogs() {
  return (
    <div className="custom-scrollbar flex h-screen flex-col overflow-auto">
      <div className="px-8 pb-2">
        <ActivityLogsState />
      </div>
    </div>
  );
}
